<div class="card">
  <app-header
    titulo="Pagamentos de Contratos"
    descricao="Realizar a integração das parcelas realizadas"
  ></app-header>

  <app-processamentocontrato statusParcela="importado"></app-processamentocontrato>

</div>
